define('modules/common/directive/FooterPanel',[], function() {
    var Directive = function($modal, LocalStorage) {

        return {
            restrict: 'E',
            /*scope: {

            },*/
            replace: true,
            templateUrl: 'modules/common/view/footer.tpl.html',
            controller: ["$scope", "RiferimentiStudio", function($scope, RiferimentiStudio) {

                var cookieModal = {
                    animation: true,
                    templateUrl: 'modules/common/view/modalCookie.tpl.html',
                    controller: 'ModalCookieController',
                    size: "lg"
                };

                var privacyModal = {
                    animation: true,
                    templateUrl: 'modules/common/view/modalPrivacy.tpl.html',
                    controller: 'ModalPrivacyController',
                    size: "lg"
                };

                $scope.openModalCookie = function() {
                    cookieModal.backdrop = true;
                    $modal.open(cookieModal);

                };

                $scope.openModalPrivacy = function() {
                    cookieModal.backdrop = true;
                    $modal.open(privacyModal);

                };

                if (!LocalStorage.getItem('DisclaimerAccept1-1-5', false)) {
                    cookieModal.backdrop = "static";
                    $modal.open(cookieModal);
                }



                RiferimentiStudio.getDati().then(function(riferimentiStudio) {
                    $scope.indirizzoPrincipale = riferimentiStudio.indirizzoprincipale;
                    $scope.indirizzoSecondario = riferimentiStudio.indirizzosecondario;
                });

            }],
            link: ["$scope", "element", "attrs", function($scope, element, attrs) {}]
        };

    };
    return ["$modal", "LocalStorage", Directive];
});
